module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-45.11a7909a.png";